export const DEFAULT_CLASS_NAMES = [
  "Nursery",
  "PG",
  "KG",
  "I",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX",
  "X",
];

export const isConfiguredCampusClass = (classItem) => {
  if (!classItem) return false;

  const hasSetup =
    Boolean(classItem.session_id) ||
    Boolean((classItem.session_ids || []).length) ||
    Boolean(classItem.section?.trim()) ||
    Boolean((classItem.sections || []).length) ||
    Boolean(classItem.description?.trim());

  return hasSetup || !DEFAULT_CLASS_NAMES.includes(classItem.name);
};

const normalizeSectionValue = (value) => String(value || "").trim();

export const classSectionsOf = (classItem, formatSection = normalizeSectionValue) => {
  const values = Array.isArray(classItem?.sections) && classItem.sections.length
    ? classItem.sections
    : classItem?.section
      ? [classItem.section]
      : [];
  return [...new Set(values.map((value) => formatSection(value)).filter(Boolean))];
};

export const classSessionIdsOf = (classItem) => {
  const values = Array.isArray(classItem?.session_ids) && classItem.session_ids.length
    ? classItem.session_ids
    : classItem?.session_id != null && classItem.session_id !== ""
      ? [classItem.session_id]
      : [];
  return [...new Set(values.map((value) => String(value || "")).filter(Boolean))];
};

export const classBelongsToSession = (classItem, sessionId) => {
  if (!sessionId) return true;
  return classSessionIdsOf(classItem).includes(String(sessionId));
};

export const filterClassesBySession = (classes, sessionId) => {
  if (!sessionId) return classes;
  return classes.filter((classItem) => classBelongsToSession(classItem, sessionId));
};

export const uniqueClassNames = (classes, { sessionId } = {}) => {
  const filtered = filterClassesBySession(classes, sessionId);
  return [...new Set(filtered.map((classItem) => classItem.name).filter(Boolean))].sort(
    (a, b) => String(a).localeCompare(String(b)),
  );
};

export const sectionsForClassSession = (
  classes,
  { sessionId, className, students = [], formatSection = normalizeSectionValue } = {},
) => {
  const sectionSet = new Set();

  filterClassesBySession(classes, sessionId)
    .filter((classItem) => !className || String(classItem.name || "") === String(className))
    .forEach((classItem) => {
      classSectionsOf(classItem, formatSection).forEach((section) => {
        if (section && section !== "—") sectionSet.add(section);
      });
    });

  if (sectionSet.size === 0 && students.length) {
    students.forEach((student) => {
      if (className && String(student.class || "") !== String(className)) return;
      const section = formatSection(student.section || student.class_section || "");
      if (section && section !== "—") sectionSet.add(section);
    });
  }

  return [...sectionSet].sort((a, b) => a.localeCompare(b));
};
